<template>

  <el-main class="main_content" style="padding: 0">

    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/help_list')">帮助说明管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a >帮助说明列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="contain_div">

      <div class="contain_header1 clr">
        <el-form style="width:850px;" ref="form" :model="form" label-width="80px" :rules="addFormRule">
          <el-form-item label="问题" prop='title'>
            <el-input v-model="form.title"></el-input>
          </el-form-item>

          <!-- <el-form-item label="详情">
            <UEditor :config=config ref="ueditor"></UEditor>
          </el-form-item> -->

          <el-form-item label="答案" prop="content">
            <el-input type="textarea" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('form')" :loading="addLoading">立即修改</el-button>
            <el-button @click="jumpTo('/help_list')">回到列表</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </el-main>
</template>


<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import { pca, pcaa } from "area-data";
// import UEditor from "@/components/ueditor.vue";
import API from "../../api/api_user";
var _ = require("lodash");
export default {
  name: "upHelp",
  // components: {UEditor},
  data() {
    return {
      config: {
        //可以在此处定义工具栏的内容
        // toolbars: [
        //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
        //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
        //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
        // ],
        autoHeightEnabled: false,
        autoFloatEnabled: true,
        initialContent: "请输入内容", //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
        autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
        initialFrameWidth: null,
        initialFrameHeight: 450,
        BaseUrl: "",
        UEDITOR_HOME_URL: "/static/ueditor/"
      },
      addFormRule: {
        title: [{ required: true, message: "请输入问题", trigger: "blur" }],

        content: [
          { required: true, message: "请填写答案", trigger: "blur" }
        ]
      },
      addLoading: false,
      fileList2: [],
      pca: pca,
      pcaa: pcaa,

      form: {
        title: "",
        intro_str: "",
        list_pic: "",
        content: null
      },
      isCollapse: true,
      activeName: "second",
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: ["阿德的", "豆得儿"]
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  mounted(e) {
    //初始化表单
    var that = this;
    var para = {
      id: this.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    API.help_get(para)
      .then(
        function(result) {
          that.form_init = false;
          if (result.key == 1000) {
            that.form.id = para.id;
            that.form.title = result.result.data.title;
            that.form.content = result.result.data.content;
            // that.$refs.ueditor.setContentInfo(result.result.data.content);
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        console.log(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
  },
  methods: {
    handleRemove(file, fileList) {
      for (var i = 0; i < this.fileList2.length; i++) {
        if (this.fileList2[i].name == file.name) {
          this.fileList2.splice(i, 1);
          return;
        }
      }
    },
    handlePreview(file) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.list_pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      }
    },
    beforeAvatarUpload: function(e) {},
    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          that.addLoading = true;
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          // let content = this.$refs.ueditor.getUEContent();
          // para.content = content;
          // if (
          //   para.content == null ||
          //   para.content == "" ||
          //   para.content == "<p>请输入内容</p>"
          // ) {
          //   that.addLoading = false;
          //   that.$message.error({
          //     showClose: true,
          //     message: "请填写帮助详细描述",
          //     duration: 2000
          //   });
          //   return;
          // }
          para.id = this.$route.query.id;
          API.help_add(para)
            .then(
              function(result) {
                that.addLoading = false;

                if (result.key == 1000) {
                  console.info(12);
                  that.$message.success({
                    showClose: true,
                    message: "修改成功",
                    duration: 1500
                  });
                  // resetForm();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}
.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}
.area-select {
  height: 40px;
}
.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px!important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/help/upHelp.vue